import React, { useState } from "react";
import PricingOrderingPlans from "./PriceComponent/PriceOrderingPlan";
import UnlimitedCTA from "./PriceComponent/Unlimited";
import ComparePlansOrdering from "./PriceComponent/ComparePlanOrdering";
import OrderNow from "./PriceComponent/Ordernow";

const PriceOrdering = () => {
  return (
    <>
      <PricingOrderingPlans />
      <UnlimitedCTA />
      <ComparePlansOrdering />
      <OrderNow />
    </>
  );
};

export default PriceOrdering;
